// Overgezet uit naslag/server/server/generateData/tasksPerCategory/Incident.ts.
import { TaskType } from '../../types/tasks.js';
import { Asset } from '../../types/assets.js';
import { InGameEffect } from '../../types/inGameEffect.js';
import { SparePart } from '../../types/storage.js';
const effect = (asset) => [
    {
        type: InGameEffect.resolveIncident,
        description: 'Veiligheids incident! Dit heeft impact op de prestatie en mogelijk productie',
        asset,
    },
];
export const IncidentTaken = [
    {
        _id: 'incident0',
        type: TaskType.incident,
        specificAsset: Asset.mixer,
        title: 'Brandwonden',
        cost: 1500,
        inGameEffectDescription: 'Veiligheids incident! Dit heeft impact op de prestatie en mogelijk productie',
        description: 'Door een lekkende afdichting van een afsluiter, heeft iemand (corrosieve) CIP vloeistof in het gezicht gekregen. Dit resulteerde in niveau 2 brandwonden.',
        inGameEffect: [InGameEffect.resolveIncident],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: effect(Asset.mixer),
    },
    {
        _id: 'incident1',
        type: TaskType.incident,
        specificAsset: Asset.mixer,
        title: 'Explosieve stofontwikkeling',
        cost: 1000,
        description: 'Door een defecte watertoevoerklep is de mixer droog gaan draaien. Daardoor is meelstof door de hele productiehal verspreid. Alles moet worden schoongemaakt en er is kans op stofexplosie ontstaan. De productie heeft daardoor stilgelegen en er is een schoonmaakploeg ingehuurd.',
        inGameEffectDescription: 'Veiligheids incident! Dit heeft impact op de prestatie en mogelijk productie',
        inGameEffect: [InGameEffect.resolveIncident],
        needsSparepart: true,
        sparepartNeeded: SparePart.watertoevoerklep,
        needsMechanic: false,
        taskEffects: effect(Asset.mixer),
    },
    {
        _id: 'incident2',
        type: TaskType.incident,
        specificAsset: Asset.vormmachineA,
        title: 'Geplette duim',
        cost: 1500,
        description: 'Bij het weghalen van koekjesresten rondom de stencils, kwam een operator met zijn vingers tussen de bewegende delen. Dit resulteerde in een geplette duim. Het lokale ziekenhuis kijkt nu wat ze voor hem kunnen doen.',
        inGameEffectDescription: 'Veiligheids incident! Dit heeft impact op de prestatie en mogelijk productie',
        inGameEffect: [InGameEffect.resolveIncident],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: effect(Asset.vormmachineA),
    },
    {
        _id: 'incident3',
        type: TaskType.incident,
        specificAsset: Asset.vormmachineA,
        title: 'Gebroken arm',
        cost: 1500,
        description: 'Een operator heeft een arm gebroken nadat een vormstencil van de wals is losgekomen en de arm heeft ingeklemd',
        inGameEffectDescription: 'Veiligheids incident! Dit heeft impact op de prestatie en mogelijk productie',
        inGameEffect: [InGameEffect.resolveIncident],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: effect(Asset.vormmachineA),
    },
    {
        _id: 'incident4',
        type: TaskType.incident,
        specificAsset: Asset.vormmachineB,
        title: 'Geplette wijsvinger',
        cost: 1500,
        description: 'Een operator kwam bij het bijstellen van de stencils met haar hand tussen de bewegende delen. Zij ligt in het ziekenhuis met een geplette wijsvinger.',
        inGameEffectDescription: 'Veiligheids incident! Dit heeft impact op de prestatie en mogelijk productie',
        inGameEffect: [InGameEffect.resolveIncident],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: effect(Asset.vormmachineB),
    },
    {
        _id: 'incident5',
        type: TaskType.incident,
        specificAsset: Asset.vormmachineB,
        title: 'Uitgegleden',
        cost: 1500,
        description: 'Door een te hoge snelheid is er deeg op de vloer belandt waardoor een operator is uitgegleden',
        inGameEffectDescription: 'Veiligheids incident! Dit heeft impact op de prestatie en mogelijk productie',
        inGameEffect: [InGameEffect.resolveIncident],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: effect(Asset.vormmachineB),
    },
    {
        _id: 'incident6',
        type: TaskType.incident,
        specificAsset: Asset.oven,
        title: 'Electrocutie',
        cost: 1000,
        description: 'In het verwarmingselement van de oven is kortsluiting ontstaan. Het verwarmingselement is daarbij beschadigd, en de operator heeft zelfs een electrische schok gekregen.',
        inGameEffectDescription: 'Veiligheids incident! Dit heeft impact op de prestatie en mogelijk productie',
        inGameEffect: [InGameEffect.resolveIncident],
        needsSparepart: true,
        sparepartNeeded: SparePart.verwarmingselement,
        needsMechanic: false,
        taskEffects: effect(Asset.oven),
    },
    {
        _id: 'incident7',
        type: TaskType.incident,
        specificAsset: Asset.oven,
        title: 'Brandwonden',
        cost: 1500,
        description: 'Een operator gebruikte zijn PBM’s (in dit geval veiligheidshandschoenen) niet tijdens het bedienen van de machine. Dit leidde tot het aanraken van de hete delen, met niveau 3 brandwonden tot gevolg. De operator zal de komende weken niet kunnen werken.',
        inGameEffectDescription: 'Veiligheids incident! Dit heeft impact op de prestatie en mogelijk productie',
        inGameEffect: [InGameEffect.resolveIncident],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: effect(Asset.oven),
    },
    {
        _id: 'incident8',
        type: TaskType.incident,
        specificAsset: Asset.koeler,
        title: 'Lekkage koelmiddel',
        cost: 1500,
        description: 'Het koelmiddel dat in de koeler wordt gebruikt is ammoniak. Door een beschadiging aan de koelinstallatie is ammoniakgas vrijgekomen binnen de productieruimte. Het gasalarm is afgegaan vanwege de giftige dampen en de brandweer is opgeroepen. Er is niemand gewond geraakt, maar de productieruimte is wel direct ontruimd.',
        inGameEffectDescription: 'Veiligheids incident! Dit heeft impact op de prestatie en mogelijk productie',
        inGameEffect: [InGameEffect.resolveIncident],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: effect(Asset.koeler),
    },
    {
        _id: 'incident9',
        type: TaskType.incident,
        specificAsset: Asset.koeler,
        title: 'Brand',
        cost: 1000,
        description: 'Door defecte luchtfilters was er een kleine brand in de koelinstallaties, de hal moest ontruimd en de brandweer ingeschakeld worden',
        inGameEffectDescription: 'Veiligheids incident! Dit heeft impact op de prestatie en mogelijk productie',
        inGameEffect: [InGameEffect.resolveIncident],
        needsSparepart: true,
        sparepartNeeded: SparePart.luchtfilters,
        needsMechanic: false,
        taskEffects: effect(Asset.koeler),
    },
    {
        _id: 'incident10',
        type: TaskType.incident,
        specificAsset: Asset.inpakker,
        title: 'Rondvliegend materiaal',
        cost: 1500,
        description: 'Door een versleten vacuumgripper is er een doos met koekjes door de fabriek gevlogen. Iemand heeft deze tegen zijn hoofd gekregen en zit thuis met een lichte hersenschudding.',
        inGameEffectDescription: 'Veiligheids incident! Dit heeft impact op de prestatie en mogelijk productie',
        inGameEffect: [InGameEffect.resolveIncident],
        needsSparepart: true,
        sparepartNeeded: SparePart.vacuumGripper,
        needsMechanic: false,
        taskEffects: effect(Asset.inpakker),
    },
    {
        _id: 'incident11',
        type: TaskType.incident,
        specificAsset: Asset.inpakker,
        title: 'Stikgevaar',
        cost: 1000,
        description: 'Omdat een operator de rol inpakfolie had vervangen zonder de machine volledig stil te zetten raakte ze verstrikt en in ademnood. ',
        inGameEffectDescription: 'Veiligheids incident! Dit heeft impact op de prestatie en mogelijk productie',
        inGameEffect: [InGameEffect.resolveIncident],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: effect(Asset.inpakker),
    },
];
